<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter class="tablet" paso="3" />
      <wrap-container class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              id="titulo"
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.paso3.titulo"
            />
            <p
              id="subtitulo"
              class="titulo oscuro"
              v-safe-html="config.pasos.paso3.subtitulo"
            />
          </wrap-container>

          <!-- Selector de PEP-->
          <wrap-container class="selector">
            <section-label
              value="¿Sos una Persona Expuesta Póliticamente (PEP)?"
            />
            <floating-tip
              :showInfoIcon="true"
              analyticsName="más información"
              description="Son personas que se desempeñan en cargos políticos o tienen vínculos familiares o de amistad con alguien que sí lo hace. "
              textMoreInfo="Una Persona Expuesta Políticamente es alguien que se desempeña o se ha desempeñado en funciones públicas destacadas, por ejemplo, jefes de Estado, políticos de alta jerarquía, funcionarios gubernamentales, judiciales o militares de alta jerarquía, altos ejecutivos de empresas estatales, funcionarios importantes de partidos políticos, etc. <br/><br/>Si nunca escuchaste hablar de este término, es muy probable que no lo seas."
              titleMoreInfo="¿Sos una Persona Expuesta Políticamente (PEP)?"
            >
              <custom-input-group
                v-model="model.pep"
                :required="true"
                name="pep"
                :analyticsTypology="config.analyticsTypology"
              >
                <radio-item
                  optionValue="1"
                  label="Si"
                  name="pep"
                  quantumObfuscate
                />
                <radio-item
                  optionValue="0"
                  label="No"
                  name="pep"
                  quantumObfuscate
                />
              </custom-input-group>
            </floating-tip>
          </wrap-container>

          <wrap-container class="selector">
            <section-label value="¿Sos Sujeto Obligado?" />
            <floating-tip
              :showInfoIcon="true"
              analyticsName="más información"
              description="Son personas que, por su actividad, deben informar operaciones ante la Unidad de Información Financiera (UIF)."
              textMoreInfo="Los Sujetos Obligados son las Personas Físicas y Jurídicas que por su actividad están señaladas como vulnerables para el Lavado de Activos y la Financiación del Terrorismo.
                            <br/><br/> Si nunca escuchaste hablar de este término, es muy probable que no lo seas."
              titleMoreInfo="¿Sos Sujeto Obligado?"
            >
              <custom-input-group
                v-model="model.sujetoObligado"
                :required="true"
                name="sujeto-obligado"
                @click="cleanActivity"
                :analyticsTypology="config.analyticsTypology"
              >
                <radio-item
                  optionValue="1"
                  label="Si"
                  name="sujeto-obligado"
                  quantumObfuscate
                />
                <radio-item
                  optionValue="0"
                  label="No"
                  name="sujeto-obligado"
                  quantumObfuscate
                />
              </custom-input-group>
            </floating-tip>
            <wrap-container v-if="esSujetoObligado">
              <work-activity-sujeto-obligado
                class="activity"
                :required="esSujetoObligado"
                v-model="model.actividadSujetoObligado"
                quantumObfuscate
              />
            </wrap-container>
          </wrap-container>
          <wrap-container class="selector">
            <section-label
              value="¿Tenés obligaciones tributarias fuera de Argentina?"
            />
            <floating-tip
              :showInfoIcon="true"
              analyticsName="más información"
              description="Es el caso de personas que pagan, o debiesen pagar, impuestos en el extranjero."
              textMoreInfo="Argentina forma parte de las Jurisdicciones que han adherido a FATCA (para Estados Unidos) y CRS (para Resto del mundo), como normativas mundiales que buscan luchar contra la evasión fiscal. Por esto, BBVA queda obligado a identificar e informar las cuentas de clientes con residencia fiscal en otros países."
              titleMoreInfo="¿Tenés obligaciones tributarias fuera de Argentina?"
            >
              <custom-input-group
                v-model="model.fatca"
                :required="true"
                name="fatca"
                :analyticsTypology="config.analyticsTypology"
              >
                <radio-item
                  optionValue="1"
                  label="Si"
                  name="fatca"
                  quantumObfuscate
                />
                <radio-item
                  optionValue="0"
                  label="No"
                  name="fatca"
                  quantumObfuscate
                />
              </custom-input-group>
            </floating-tip>
          </wrap-container>
          <step-navigator
            v-model="model"
            store-action="DO_PASO3"
            analyticsName="continuar"
          />
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepCounter from "@/components/core/StepCounter";
import SectionLabel from "@/components/core/SectionLabel";
import RadioItem from "@/components/core/custom/RadioItem";
import FloatingTip from "@/components/core/custom/FloatingTip";
import CustomInputGroup from "@/components/core/custom/CustomInputGroup";
import StepNavigator from "@/components/core/StepNavigator";
import WorkActivitySujetoObligado from "@/components/core/WorkActivitySujetoObligado";

export default {
  name: "Paso3",
  components: {
    WrapContainer,
    FormValidator,
    StepCounter,
    SectionLabel,
    RadioItem,
    FloatingTip,
    CustomInputGroup,
    StepNavigator,
    WorkActivitySujetoObligado
  },
  data() {
    return {
      model: this.$store.getters.getPaso3()
    };
  },
  computed: {
    esSujetoObligado() {
      return this.model.sujetoObligado === "1";
    }
  },
  methods: {
    cleanActivity() {
      if (this.model.sujetoObligado === "0")
        this.model.actividadSujetoObligado = "";
    }
  },
  mounted() {
    /* Si no hay oferta... Vuelvo a la consulta */
    if (PRODUCTION && !this.$store.state.dataOferta.oferta.valid) {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
#titulo {
  margin-bottom: 16px;
}
#subtitulo {
  margin-bottom: 40px;
}
.selector {
  margin-bottom: 40px;
}
.activity {
  margin-top: 20px;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
  }
  .activity {
    margin-top: 0px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .w50 {
    width: 50%;
    margin-left: 7%;
    max-width: 1024px;
  }

  .cascade {
    display: block;
  }

  .tablet {
    margin-left: 7%;
  }
}
</style>
